import React, { useState } from "react"
import _ from "lodash"
import trcss from "../../../styles/Telerecovery.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { LoaderMedium } from "../../../components/Loaders"
import BroadcastMessage from "./BroadcastMessage"
import { truncateString } from "../Utils"

export default function BroadcastChat({ group, loadingGroupData }) {
  const [loadingMessages] = useState(false)
  return (
    <div className={trcss.chatWrapper}>
      {loadingGroupData === false && (
        <div
          className={trcss.chatWindow}
          style={{
            padding: "20px",
            height: "800px",
            gridTemplateColumns: "200px 1fr",
            display: "grid",
          }}
        >
          <div>
            <div className={trcss.chatWindowHeader}>
              <span className={trcss.headerParticipantName} style={{ fontSize: "12px", fontWeight: "600" }}>
                Participant List ({group.participants.length})
              </span>
            </div>
            <div style={{
              paddingTop: "10px",
              height: "735px",
              backgroundColor: "#E7E0F180",
              width: "95%"
            }}>
              <ul style={{
                height: "720px",
                overflow: "auto",
                paddingLeft: "29px",
                listStyle: "disc",
                marginRight: "8px"
              }} className={gMessages.myScrollbarSmall}>
                {group.participants.map((participantName) => {
                  return <li style={{ color: "#383838", fontSize: "12px" }}>{truncateString(participantName, 20)}</li>
                })}
              </ul>
            </div>
          </div>
          <div>
            <div className={trcss.chatWindowHeader}>
              <span className={trcss.headerParticipantName} style={{ fontSize: "12px", fontWeight: "600" }}>
                {group.groupName}
              </span>
            </div>
            <div className={trcss.chatHistoryContainer}>
              {loadingMessages === true && <LoaderMedium />}
              {(!group.messages || group.messages.length === 0) &&
                !loadingMessages && (
                  <span className={trcss.convEmptyMsg}>
                    This conversation is empty.
                  </span>
                )}
              <ul className={trcss.chatWindowList}>
                {!loadingMessages &&
                  group.messages &&
                  group.messages.map((msg, i) => (
                    <li key={"msg-" + i}>
                      <BroadcastMessage message={msg}></BroadcastMessage>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      {loadingGroupData === true && <LoaderMedium></LoaderMedium>}
    </div>
  )
}